<template>
  <div class="myshare">
    <Header titles="我的分享"></Header>
    <!-- <div class="share-tab">
      <router-link to="/myshare/friend" class="fri" replace>
        <div class="tabk" @click="active=1">好友</div>
      </router-link>
      <router-link to="/myshare/tasking" class="tabc" replace>
        <div class="tabk" @click="active=2">任务</div>
      </router-link>
    </div> -->
    <router-view></router-view>
  </div>
</template>

<script>
import Header from "@/components/header";

export default {
  data() {
    return {
      active: 1
    };
  },
  components: {
    Header,
  },
  created() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.myshare {
  padding-top: 54px;
  .share-tab {
    display: flex;
    justify-content: center;
    width: 194px;
    text-align: center;
    height: 34px;
    line-height: 34px;
    background-color: #ccc;
    margin: 0 auto;
    border-radius: 20px;
    div {
      width: 97px;
    }
    .fri {
      color: #afaeae;
      &.router-link-active .tabk {
        background-color: #4464eb;
        color: white;
        border-radius: 20px 0 0 20px ;
      }
    }
    .tabc {
      color: #afaeae;
      &.router-link-active .tabk {
        background-color: #4464eb;
        color: white;
        border-radius:0 20px 20px 0;
      }
    }
  }
}
</style>